"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LanguageSelectDialog;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function LanguageSelectDialog(props) {
  var languageChoices = getLanguageChoices();

  var languageChoicesKeys = _toConsumableArray(Object.keys(languageChoices));

  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      regionOpen = _React$useState2[0],
      setRegionOpen = _React$useState2[1];

  var _React$useState3 = _react.default.useState({
    "": ""
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      regionOptions = _React$useState4[0],
      setRegionOptions = _React$useState4[1];

  var _React$useState5 = _react.default.useState(""),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      selectedAbrLanguage = _React$useState6[0],
      setSelectedAbrLanguage = _React$useState6[1];

  var _React$useState7 = _react.default.useState(""),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      selectedLanguage = _React$useState8[0],
      setSelectedLanguage = _React$useState8[1];

  var _React$useState9 = _react.default.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      supportAlert = _React$useState10[0],
      setSupportAlert = _React$useState10[1];

  var _React$useState11 = _react.default.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      openAlert = _React$useState12[0],
      setOpenAlert = _React$useState12[1];

  var handleCloseAlert = function handleCloseAlert(event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    setOpenAlert(false);
  };

  var onClose = props.onClose,
      selectedValue = props.selectedValue,
      open = props.open;

  var handleClose = function handleClose() {
    onClose(selectedValue);
    setRegionOpen(false);
    setRegionOptions({});
  };

  var handleListLanguageClick = function handleListLanguageClick(language, abrLanguage) {
    setSelectedLanguage(language);
    var languageObj = languageChoices[language];
    var azureLanguageOptions = {};
    if (languageObj["azureSpeechToTextAbr"] != null) Object.keys(languageObj["azureSpeechToTextAbr"]).forEach(function (key) {
      return azureLanguageOptions[key] = languageObj["azureSpeechToTextAbr"][key];
    });
    if (languageObj["azureTextToSpeechAbr"] != null) Object.keys(languageObj["azureTextToSpeechAbr"]).forEach(function (key) {
      return azureLanguageOptions[key] = languageObj["azureTextToSpeechAbr"][key];
    }); //reset alert state 

    setOpenAlert(false);

    if (Object.keys(azureLanguageOptions).length > 0) {
      setSelectedAbrLanguage(abrLanguage["googleTranslateAbr"]);
      setRegionOptions(azureLanguageOptions);
      setRegionOpen(true);
    } else {
      //inform user of language support
      setSupportAlert("Text to speech and Speech to text is not supported for your selected language");
      setOpenAlert(true);
      onClose(language, abrLanguage["googleTranslateAbr"], null, {
        "s2t": false,
        "t2s": false
      });
    }
  };

  var handleListRegionClick = function handleListRegionClick(region, abrRegion) {
    var s2tSupported = languageChoices[selectedLanguage]["azureSpeechToTextAbr"] != null && languageChoices[selectedLanguage]["azureSpeechToTextAbr"][region] != null;
    var t2sSupported = languageChoices[selectedLanguage]["azureTextToSpeechAbr"] != null && languageChoices[selectedLanguage]["azureTextToSpeechAbr"][region] != null; //inform user of language support

    if (!s2tSupported) {
      setSupportAlert("Speech to text is not supported for your selected language");
      setOpenAlert(true);
    } else if (!t2sSupported) {
      setSupportAlert("Text to speech is not supported for your selected language");
      setOpenAlert(true);
    }

    onClose(region, selectedAbrLanguage, abrRegion, {
      "s2t": s2tSupported,
      "t2s": t2sSupported
    });
    setRegionOpen(false);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Dialog, {
    onClose: handleClose,
    "aria-labelledby": "simple-dialog-title",
    open: open
  }, /*#__PURE__*/_react.default.createElement(_material.DialogTitle, {
    id: "simple-dialog-title",
    tabIndex: "0"
  }, "Select language"), /*#__PURE__*/_react.default.createElement(_material.List, null, languageChoicesKeys.map(function (language) {
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      button: true,
      onClick: function onClick() {
        return handleListLanguageClick(language, languageChoices[language]);
      },
      key: languageChoices[language]
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      primary: language
    }));
  }))), /*#__PURE__*/_react.default.createElement(_material.Dialog, {
    onClose: handleClose,
    "aria-labelledby": "simple-dialog-title",
    open: regionOpen
  }, /*#__PURE__*/_react.default.createElement(_material.DialogTitle, {
    id: "simple-dialog-title",
    tabIndex: "0"
  }, "Select language"), /*#__PURE__*/_react.default.createElement(_material.List, null, Object.keys(regionOptions).map(function (region) {
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      button: true,
      onClick: function onClick() {
        return handleListRegionClick(region, regionOptions[region]);
      },
      key: regionOptions[region]
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      primary: region
    }));
  }))), /*#__PURE__*/_react.default.createElement(_material.Snackbar, {
    open: openAlert,
    autoHideDuration: 8000,
    onClose: handleCloseAlert
  }, /*#__PURE__*/_react.default.createElement(_material.Alert, {
    onClose: handleCloseAlert,
    severity: "warning",
    sx: {
      width: '100%'
    }
  }, supportAlert)));
}

LanguageSelectDialog.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired,
  selectedValue: _propTypes.default.string.isRequired
};

function getLanguageChoices() {
  var languageChoices = {
    "Afrikaans": {
      "googleTranslateAbr": "af",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Afrikaans (South Africa)": "af-ZA"
      }
    },
    "Albanian": {
      "googleTranslateAbr": "sq",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Amharic": {
      "googleTranslateAbr": "am",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Amharic (Ethiopia)": "am-ET"
      }
    },
    "Arabic": {
      "googleTranslateAbr": "ar",
      "azureSpeechToTextAbr": {
        "Arabic (Algeria)": "ar-DZ",
        "Arabic (Bahrain)": "ar-BH",
        "Arabic (Egypt)": "ar-EG",
        "Arabic (Iraq)": "ar-IQ",
        "Arabic (Israel)": "ar-IL",
        "Arabic (Jordan)": "ar-JO",
        "Arabic (Kuwait)": "ar-KW",
        "Arabic (Lebanon)": "ar-LB",
        "Arabic (Libya)": "ar-LY",
        "Arabic (Morocco)": "ar-MA",
        "Arabic (Oman)": "ar-OM",
        "Arabic (Qatar)": "ar-QA",
        "Arabic (Saudi Arabia)": "ar-SA",
        "Arabic (Palestinian Authority)": "ar-PS",
        "Arabic (Syria)": "ar-SY",
        "Arabic (Tunisia)": "ar-TN",
        "Arabic (United Arab Emirates)": "ar-AE",
        "Arabic (Yemen)": "ar-YE"
      },
      "azureTextToSpeechAbr": {
        "Arabic (Algeria)": "ar-DZ",
        "Arabic (Bahrain)": "ar-BH",
        "Arabic (Egypt)": "ar-EG",
        "Arabic (Iraq)": "ar-IQ",
        "Arabic (Jordan)": "ar-JO",
        "Arabic (Kuwait)": "ar-KW",
        "Arabic (Libya)": "ar-LY",
        "Arabic (Morocco)": "ar-MA",
        "Arabic (Qatar)": "ar-QA",
        "Arabic (Saudi Arabia)": "ar-SA",
        "Arabic (Syria)": "ar-SY",
        "Arabic (Tunisia)": "ar-TN",
        "Arabic (United Arab Emirates)": "ar-AE",
        "Arabic (Yemen)": "ar-YE"
      }
    },
    "Armenian": {
      "googleTranslateAbr": "hy",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Azerbaijani": {
      "googleTranslateAbr": "az",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Bangla ": {
      "googleTranslateAbr": null,
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Bangla (Bangladesh)": "bn-BD"
      }
    },
    "Basque": {
      "googleTranslateAbr": "eu",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Belarusian": {
      "googleTranslateAbr": "be",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Bengali": {
      "googleTranslateAbr": "bn",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Bosnian": {
      "googleTranslateAbr": "bs",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Bulgarian": {
      "googleTranslateAbr": "bg",
      "azureSpeechToTextAbr": {
        "Bulgarian (Bulgaria)": "bg-BG"
      },
      "azureTextToSpeechAbr": {
        "Bulgarian (Bulgaria)": "bg-BG"
      }
    },
    "Burmese": {
      "googleTranslateAbr": "My",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Burmese (Myanmar)": "my-MM"
      }
    },
    "Catalan": {
      "googleTranslateAbr": "ca",
      "azureSpeechToTextAbr": {
        "Catalan (Spain)": "ca-ES"
      },
      "azureTextToSpeechAbr": {
        "Catalan (Spain)": "ca-ES"
      }
    },
    "Cebuano": {
      "googleTranslateAbr": "ceb (ISO-639-2)",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Chinese (Simplified)": {
      "googleTranslateAbr": "zh-CN",
      "azureSpeechToTextAbr": {
        "Chinese (Simplified)": "zh-CN"
      },
      "azureTextToSpeechAbr": {
        "Chinese (Simplified)": "zh-CN"
      }
    },
    "Chinese (Traditional)": {
      "googleTranslateAbr": "zh-TW",
      "azureSpeechToTextAbr": {
        "Chinese (Traditional)": "zh-TW"
      },
      "azureTextToSpeechAbr": {
        "Chinese (Traditional)": "zh-TW"
      }
    },
    "Corsican": {
      "googleTranslateAbr": "co",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Croatian": {
      "googleTranslateAbr": "hr",
      "azureSpeechToTextAbr": {
        "Croatian (Croatia)": "hr-HR"
      },
      "azureTextToSpeechAbr": {
        "Croatian (Croatia)": "hr-HR"
      }
    },
    "Czech": {
      "googleTranslateAbr": "cs",
      "azureSpeechToTextAbr": {
        "Czech (Czech Republic)": "cs-CZ"
      },
      "azureTextToSpeechAbr": {
        "Czech (Czech Republic)": "cs-CZ"
      }
    },
    "Danish": {
      "googleTranslateAbr": "da",
      "azureSpeechToTextAbr": {
        "Danish (Denmark)": "da-DK"
      },
      "azureTextToSpeechAbr": {
        "Danish (Denmark)": "da-DK"
      }
    },
    "Dutch": {
      "googleTranslateAbr": "nl",
      "azureSpeechToTextAbr": {
        "Dutch (Netherlands)": "nl-NL"
      },
      "azureTextToSpeechAbr": {
        "Dutch (Belgium)": "nl-BE",
        "Dutch (Netherlands)": "nl-NL"
      }
    },
    "English": {
      "googleTranslateAbr": "en",
      "azureSpeechToTextAbr": {
        "English (Australia)": "en-AU",
        "English (Canada)": "en-CA",
        "English (Ghana)": "en-GH",
        "English (Hongkong)": "en-HK",
        "English (India)": "en-IN",
        "English (Ireland)": "en-IE",
        "English (Kenya)": "en-KE",
        "English (New Zealand)": "en-NZ",
        "English (Nigeria)": "en-NG",
        "English (Philippines)": "en-PH",
        "English (Singapore)": "en-SG",
        "English (South Africa)": "en-ZA",
        "English (Tanzanian)": "en-TZ",
        "English (United Kingdom)": "en-GB",
        "English (United States)": "en-US"
      },
      "azureTextToSpeechAbr": {
        "English (Australia)": "en-AU",
        "English (Canada)": "en-CA",
        "English (Hongkong)": "en-HK",
        "English (India)": "en-IN",
        "English (Ireland)": "en-IE",
        "English (Kenya)": "en-KE",
        "English (New Zealand)": "en-NZ",
        "English (Nigeria)": "en-NG",
        "English (Philippines)": "en-PH",
        "English (Singapore)": "en-SG",
        "English (South Africa)": "en-ZA",
        "English (Tanzanian)": "en-TZ",
        "English (United Kingdom)": "en-GB",
        "English (United States)": "en-US"
      }
    },
    "Esperanto": {
      "googleTranslateAbr": "eo",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Estonian": {
      "googleTranslateAbr": "et",
      "azureSpeechToTextAbr": {
        "Estonian (Estonia)": "et-EE"
      },
      "azureTextToSpeechAbr": {
        "Estonian (Estonia)": "et-EE"
      }
    },
    "Filipino ": {
      "googleTranslateAbr": "tl",
      "azureSpeechToTextAbr": {
        "Filipino (Philippines)": "fil-PH"
      },
      "azureTextToSpeechAbr": {
        "Filipino (Philippines)": "fil-PH"
      }
    },
    "Finnish": {
      "googleTranslateAbr": "fi",
      "azureSpeechToTextAbr": {
        "Finnish (Finland)": "fi-FI"
      },
      "azureTextToSpeechAbr": {
        "Finnish (Finland)": "fi-FI"
      }
    },
    "French": {
      "googleTranslateAbr": "fr",
      "azureSpeechToTextAbr": {
        "French (Canada)": "fr-CA",
        "French (France)": "fr-FR",
        "French (Switzerland)": "fr-CH"
      },
      "azureTextToSpeechAbr": {
        "French (Belgium)": "fr-BE",
        "French (Canada)": "fr-CA",
        "French (France)": "fr-FR",
        "French (Switzerland)": "fr-CH"
      }
    },
    "Frisian": {
      "googleTranslateAbr": "fy",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Galician": {
      "googleTranslateAbr": "gl",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Galician (Galician)": "gl-ES"
      }
    },
    "Georgian": {
      "googleTranslateAbr": "ka",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "German": {
      "googleTranslateAbr": "de",
      "azureSpeechToTextAbr": {
        "German (Austria)": "de-AT",
        "German (Germany)": "de-DE"
      },
      "azureTextToSpeechAbr": {
        "German (Austria)": "de-AT",
        "German (Germany)": "de-DE",
        "German (Switzerland)": "de-CH"
      }
    },
    "Greek": {
      "googleTranslateAbr": "el",
      "azureSpeechToTextAbr": {
        "Greek (Greece)": "el-GR"
      },
      "azureTextToSpeechAbr": {
        "Greek (Greece)": "el-GR"
      }
    },
    "Gujarati": {
      "googleTranslateAbr": "gu",
      "azureSpeechToTextAbr": {
        "Gujarati (India)": "gu-IN"
      },
      "azureTextToSpeechAbr": {
        "Gujarati (India)": "gu-IN"
      }
    },
    "Haitian Creole": {
      "googleTranslateAbr": "ht",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Hausa": {
      "googleTranslateAbr": "ha",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Hawaiian": {
      "googleTranslateAbr": "haw (ISO-639-2)",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Hebrew": {
      "googleTranslateAbr": "he or iw",
      "azureSpeechToTextAbr": {
        "Hebrew": "he-IL"
      },
      "azureTextToSpeechAbr": {
        "Hebrew": "he-IL"
      }
    },
    "Hindi": {
      "googleTranslateAbr": "hi",
      "azureSpeechToTextAbr": {
        "Hindi (India)": "hi-IN"
      },
      "azureTextToSpeechAbr": {
        "Hindi (India)": "hi-IN"
      }
    },
    "Hmong": {
      "googleTranslateAbr": "hmn (ISO-639-2)",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Hungarian": {
      "googleTranslateAbr": "hu",
      "azureSpeechToTextAbr": {
        "Hungarian (Hungary)": "hu-HU"
      },
      "azureTextToSpeechAbr": {
        "Hungarian (Hungary)": "hu-HU"
      }
    },
    "Icelandic": {
      "googleTranslateAbr": "is",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Igbo": {
      "googleTranslateAbr": "ig",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Indonesian": {
      "googleTranslateAbr": "id",
      "azureSpeechToTextAbr": {
        "Indonesian (Indonesia)": "id-ID"
      },
      "azureTextToSpeechAbr": {
        "Indonesian (Indonesia)": "id-ID"
      }
    },
    "Irish": {
      "googleTranslateAbr": "ga",
      "azureSpeechToTextAbr": {
        "Irish (Ireland)": "ga-IE"
      },
      "azureTextToSpeechAbr": {
        "Irish (Ireland)": "ga-IE"
      }
    },
    "Italian": {
      "googleTranslateAbr": "it",
      "azureSpeechToTextAbr": {
        "Italian (Italy)": "it-IT"
      },
      "azureTextToSpeechAbr": {
        "Italian (Italy)": "it-IT"
      }
    },
    "Japanese": {
      "googleTranslateAbr": "ja",
      "azureSpeechToTextAbr": {
        "Japanese (Japan)": "ja-JP"
      },
      "azureTextToSpeechAbr": {
        "Japanese (Japan)": "ja-JP"
      }
    },
    "Javanese": {
      "googleTranslateAbr": "jv",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Kannada": {
      "googleTranslateAbr": "kn",
      "azureSpeechToTextAbr": {
        "Kannada (India)": "kn-IN"
      },
      "azureTextToSpeechAbr": null
    },
    "Kazakh": {
      "googleTranslateAbr": "kk",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Khmer": {
      "googleTranslateAbr": "km",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Khmer (Cambodia)": "km-KH"
      }
    },
    "Kinyarwanda": {
      "googleTranslateAbr": "rw",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Korean": {
      "googleTranslateAbr": "ko",
      "azureSpeechToTextAbr": {
        "Korean (Korea)": "ko-KR"
      },
      "azureTextToSpeechAbr": {
        "Korean (Korea)": "ko-KR"
      }
    },
    "Kurdish": {
      "googleTranslateAbr": "ku",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Kyrgyz": {
      "googleTranslateAbr": "ky",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Lao": {
      "googleTranslateAbr": "lo",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Latvian": {
      "googleTranslateAbr": "lv",
      "azureSpeechToTextAbr": {
        "Latvian (Latvia)": "lv-LV"
      },
      "azureTextToSpeechAbr": {
        "Latvian (Latvia)": "lv-LV"
      }
    },
    "Lithuanian": {
      "googleTranslateAbr": "lt",
      "azureSpeechToTextAbr": {
        "Lithuanian (Lithuania)": "lt-LT"
      },
      "azureTextToSpeechAbr": {
        "Lithuanian (Lithuania)": "lt-LT"
      }
    },
    "Luxembourgish": {
      "googleTranslateAbr": "lb",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Macedonian": {
      "googleTranslateAbr": "mk",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Malagasy": {
      "googleTranslateAbr": "mg",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Malay": {
      "googleTranslateAbr": "ms",
      "azureSpeechToTextAbr": {
        "Malay (Malaysia)": "ms-MY"
      },
      "azureTextToSpeechAbr": {
        "Malay (Malaysia)": "ms-MY"
      }
    },
    "Malayalam": {
      "googleTranslateAbr": "ml",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Maltese": {
      "googleTranslateAbr": "mt",
      "azureSpeechToTextAbr": {
        "Maltese (Malta)": "mt-MT"
      },
      "azureTextToSpeechAbr": {
        "Maltese (Malta)": "mt-MT"
      }
    },
    "Maori": {
      "googleTranslateAbr": "mi",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Marathi": {
      "googleTranslateAbr": "mr",
      "azureSpeechToTextAbr": {
        "Marathi (India)": "mr-IN"
      },
      "azureTextToSpeechAbr": {
        "Marathi (India)": "mr-IN"
      }
    },
    "Mongolian": {
      "googleTranslateAbr": "mn",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Nepali": {
      "googleTranslateAbr": "ne",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Norwegian": {
      "googleTranslateAbr": "no",
      "azureSpeechToTextAbr": {
        "Norwegian (Norway)": "no-NO"
      },
      "azureTextToSpeechAbr": {
        "Norwegian (Norway)": "nb-NO"
      }
    },
    "Nyanja (Chichewa)": {
      "googleTranslateAbr": "ny",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Odia (Oriya)": {
      "googleTranslateAbr": "or",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Pashto": {
      "googleTranslateAbr": "ps",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Persian": {
      "googleTranslateAbr": "fa",
      "azureSpeechToTextAbr": {
        "Persian (Iran)": "fa-IR"
      },
      "azureTextToSpeechAbr": {
        "Persian (Iran)": "fa-IR"
      }
    },
    "Polish": {
      "googleTranslateAbr": "pl",
      "azureSpeechToTextAbr": {
        "Polish (Poland)": "pl-PL"
      },
      "azureTextToSpeechAbr": {
        "Polish (Poland)": "pl-PL"
      }
    },
    "Portuguese": {
      "googleTranslateAbr": "pt",
      "azureSpeechToTextAbr": {
        "Portuguese (Brazil)": "pt-BR",
        "Portuguese (Portugal)": "pt-PT"
      },
      "azureTextToSpeechAbr": {
        "Portuguese (Brazil)": "pt-BR",
        "Portuguese (Portugal)": "pt-PT"
      }
    },
    "Punjabi": {
      "googleTranslateAbr": "pa",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Romanian": {
      "googleTranslateAbr": "ro",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Romanian (Romania)": "ro-RO"
      }
    },
    "Russian": {
      "googleTranslateAbr": "ru",
      "azureSpeechToTextAbr": {
        "Russian (Russia)": "ru-RU"
      },
      "azureTextToSpeechAbr": {
        "Russian (Russia)": "ru-RU"
      }
    },
    "Samoan": {
      "googleTranslateAbr": "sm",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Scots Gaelic": {
      "googleTranslateAbr": "gd",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Serbian": {
      "googleTranslateAbr": "sr",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Sesotho": {
      "googleTranslateAbr": "st",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Shona": {
      "googleTranslateAbr": "sn",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Sindhi": {
      "googleTranslateAbr": "sd",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Sinhala": {
      "googleTranslateAbr": "si",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Slovak": {
      "googleTranslateAbr": "sk",
      "azureSpeechToTextAbr": {
        "Slovak (Slovakia)": "sk-SK"
      },
      "azureTextToSpeechAbr": {
        "Slovak (Slovakia)": "sk-SK"
      }
    },
    "Slovenian": {
      "googleTranslateAbr": "sl",
      "azureSpeechToTextAbr": {
        "Slovenian (Slovenia)": "sl-SI"
      },
      "azureTextToSpeechAbr": {
        "Slovenian (Slovenia)": "sl-SI"
      }
    },
    "Somali": {
      "googleTranslateAbr": "so",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Somali (Somalia)": "so-SO"
      }
    },
    "Spanish": {
      "googleTranslateAbr": "es",
      "azureSpeechToTextAbr": {
        "Spanish (Argentina)": "es-AR",
        "Spanish (Bolivia)": "es-BO",
        "Spanish (Chile)": "es-CL",
        "Spanish (Colombia)": "es-CO",
        "Spanish (Costa Rica)": "es-CR",
        "Spanish (Cuba)": "es-CU",
        "Spanish (Dominican Republic)": "es-DO",
        "Spanish (Ecuador)": "es-EC",
        "Spanish (El Salvador)": "es-SV",
        "Spanish (Equatorial Guinea)": "es-GQ",
        "Spanish (Guatemala)": "es-GT",
        "Spanish (Honduras)": "es-HN",
        "Spanish (Mexico)": "es-MX",
        "Spanish (Nicaragua)": "es-NI",
        "Spanish (Panama)": "es-PA",
        "Spanish (Paraguay)": "es-PY",
        "Spanish (Peru)": "es-PE",
        "Spanish (Puerto Rico)": "es-PR",
        "Spanish (Spain)": "es-ES",
        "Spanish (Uruguay)": "es-UY",
        "Spanish (United States)": "es-US",
        "Spanish (Venezuela)": "es-VE"
      },
      "azureTextToSpeechAbr": {
        "Spanish (Argentina)": "es-AR",
        "Spanish (Bolivia)": "es-BO",
        "Spanish (Chile)": "es-CL",
        "Spanish (Colombia)": "es-CO",
        "Spanish (Costa Rica)": "es-CR",
        "Spanish (Cuba)": "es-CU",
        "Spanish (Dominican Republic)": "es-DO",
        "Spanish (Ecuador)": "es-EC",
        "Spanish (El Salvador)": "es-SV",
        "Spanish (Equatorial Guinea)": "es-GQ",
        "Spanish (Guatemala)": "es-GT",
        "Spanish (Honduras)": "es-HN",
        "Spanish (Mexico)": "es-MX",
        "Spanish (Nicaragua)": "es-NI",
        "Spanish (Panama)": "es-PA",
        "Spanish (Paraguay)": "es-PY",
        "Spanish (Peru)": "es-PE",
        "Spanish (Puerto Rico)": "es-PR",
        "Spanish (Spain)": "es-ES",
        "Spanish (Uruguay)": "es-UY",
        "Spanish (United States)": "es-US",
        "Spanish (Venezuela)": "es-VE"
      }
    },
    "Sundanese": {
      "googleTranslateAbr": "su",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Sundanese (Indonesia)": "su-ID"
      }
    },
    "Swahili": {
      "googleTranslateAbr": "sw",
      "azureSpeechToTextAbr": {
        "Swahili (Kenya)": "sw-KE"
      },
      "azureTextToSpeechAbr": {
        "Swahili (Kenya)": "sw-KE",
        "Swahili (Tanzania)": "sw-TZ"
      }
    },
    "Swedish": {
      "googleTranslateAbr": "sv",
      "azureSpeechToTextAbr": {
        "Swedish (Sweden)": "sv-SE"
      },
      "azureTextToSpeechAbr": {
        "Swedish (Sweden)": "sv-SE"
      }
    },
    "Tajik": {
      "googleTranslateAbr": "tg",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Tamil": {
      "googleTranslateAbr": "ta",
      "azureSpeechToTextAbr": {
        "Tamil (India)": "ta-IN"
      },
      "azureTextToSpeechAbr": {
        "Tamil (India)": "ta-IN",
        "Tamil (Singapore)": "ta-SG",
        "Tamil (Sri Lanka)": "ta-LK"
      }
    },
    "Tatar": {
      "googleTranslateAbr": "tt",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Telugu": {
      "googleTranslateAbr": "te",
      "azureSpeechToTextAbr": {
        "Telugu (India)": "te-IN"
      },
      "azureTextToSpeechAbr": {
        "Telugu (India)": "te-IN"
      }
    },
    "Thai": {
      "googleTranslateAbr": "th",
      "azureSpeechToTextAbr": {
        "Thai (Thailand)": "th-TH"
      },
      "azureTextToSpeechAbr": {
        "Thai (Thailand)": "th-TH"
      }
    },
    "Turkish": {
      "googleTranslateAbr": "tr",
      "azureSpeechToTextAbr": {
        "Turkish (Turkey)": "tr-TR"
      },
      "azureTextToSpeechAbr": {
        "Turkish (Turkey)": "tr-TR"
      }
    },
    "Turkmen": {
      "googleTranslateAbr": "tk",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Ukrainian": {
      "googleTranslateAbr": "uk",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Ukrainian (Ukraine)": "uk-UA"
      }
    },
    "Urdu": {
      "googleTranslateAbr": "ur",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Urdu (India)": "ur-IN",
        "Urdu (Pakistan)": "ur-PK"
      }
    },
    "Uyghur": {
      "googleTranslateAbr": "ug",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Uzbek": {
      "googleTranslateAbr": "uz",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Uzbek (Uzbekistan)": "uz-UZ"
      }
    },
    "Vietnamese": {
      "googleTranslateAbr": "vi",
      "azureSpeechToTextAbr": {
        "Vietnamese (Vietnam)": "vi-VN"
      },
      "azureTextToSpeechAbr": {
        "Vietnamese (Vietnam)": "vi-VN"
      }
    },
    "Welsh": {
      "googleTranslateAbr": "cy",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Welsh (United Kingdom)": "cy-GB"
      }
    },
    "Xhosa": {
      "googleTranslateAbr": "xh",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Yiddish": {
      "googleTranslateAbr": "yi",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Yoruba": {
      "googleTranslateAbr": "yo",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": null
    },
    "Zulu": {
      "googleTranslateAbr": "zu",
      "azureSpeechToTextAbr": null,
      "azureTextToSpeechAbr": {
        "Zulu (South Africa)": "zu-ZA"
      }
    }
  };
  return languageChoices;
}